import React from "react";

const CategoryDropdownRoles = ({ selectHandler, elValue}) => {
  const L2List =  ["USER", "ADMIN", "TEACHER"];
  
  return (
    
    <select value={elValue} 
    name="ROLE" 
    id="ROLE" 
    className="h-12 border-4 border-teal-400 rounded-md p-2 text-xl" 
    onChange={selectHandler}
>


{L2List.map(
    (les,i) => 
        {
            return (
                <option value={les} key={les}>
                    {les}
                </option>
            );
        }
    )
}           
</select>
    
    
    
    
    
   
  );
};


export default CategoryDropdownRoles;
